<template>
  <div>
    <div class="marTML pf23-subTit">
      <div class="widM fntH4 bold padTS padBS" style="color:#fff;">참가자 정보</div>
    </div>
    <div class="widM padTSM">
      <ul class="osResNoticeList fntE colorGray" style="padding-left:.5em; text-indent:-.5em;">
        <li>- <em style="color:#e11e45">*</em> 표시는 필수 입력사항입니다.</li>
        <li>- 첨부파일은 JPG, PNG, PDF, HEIC, HEIF 형식으로 최대 10MB까지 등록하실 수 있습니다.</li>
      </ul>
    </div>

    <div class="pf23-inFo-wrap">
      <div class="widM clearfix" v-if="mainResponses"> 
        <template v-for="(mainAttendant, idx) in mainResponses" >
          <SurveyParticipant
            :key="`mainAttendant${idx}`"
            :seq="idx"
            :participant="mainAttendant"
          />
          <span
            :key="`mainAttendant_span${idx}`"
            class="disIb moOnly" style="padding:2.5px;"
          />
          <hr
            v-if="idx < mainResponses.length - 1"
            :key="`mainAttendant_hr${idx}`"
            class="moOnly"
            style="border-top:1px solid #ddd; background:#f4f4f4; padding:5px 0;"
          />
        </template>
      </div>

      <!-- 안전 확인 : PC 인 경우는 주/부 에 대해서 표시된다. Mo 인 경우는 부 or 배우자인경우만 표시된다. 신기한 Style -->
      <SurveyParticipantSafe :infoAvailable="infoAvailable" />
      
    </div>

  </div>
</template>

<script>
import SurveyParticipant from './SurveyParticipant.vue'
import SurveyParticipantSafe from './SurveyParticipantSafe.vue'
import { SURVEY_SINGAPORE, INFO_AVAILABLE, ATTENDING_LIST, MAIN_RESPONSES, FAMILY_RESPONSES, MEMBER_ATTENDANTS } from '@/store/actions/survey'
import { mapState, mapGetters } from 'vuex'
import { CommonMethodMixin } from '../mixins'
import { getMessage } from '@/utils/survey'

export default {
  name: 'SurveyParticipantInfo',
  mixins: [CommonMethodMixin],
  components: {
    SurveyParticipant,
    SurveyParticipantSafe,
  },
  computed: {
    ...mapState(SURVEY_SINGAPORE, {
      responses: state => state.responses,
    }),
    ...mapGetters(SURVEY_SINGAPORE, {
      infoAvailable: INFO_AVAILABLE,
      attendingList: ATTENDING_LIST,
      mainResponses: MAIN_RESPONSES,
      familyResponses: FAMILY_RESPONSES,
      memberAttendants: MEMBER_ATTENDANTS,
    }),
    existMemberAttendant () {
      // return this.memberAttendants.length > 0;
      return false
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/singapore/components/SurveyParticipantInfo.vue